import { getCookie, setCookie } from '../cookies';

// Скрыть/показать попап про куки
function checkCookie() {
    if (!getCookie("cookieHide")) {
        $(".cookie_box").addClass("show");
    } else {
        $(".cookie_box").removeClass("show");
    }
}

$(() => {
    checkCookie();

    // Клик по кнопке ОК в попапе с куки
    $(document).on("click", ".cookie-btn", function () {
        setCookie("cookieHide", "hide", { expires: 365 * 24 * 60 * 60 });
        checkCookie();
    });
});
